export default __webpack_public_path__ + "static/dte-758ac6f92f10fe1d2585239a6a529a70.png";